import { Model } from ".";

export default class YardDeliveryNoteReport extends Model {
	get singularNoun() {
		return "delivery note report";
	}

	resource() {
		return "yard/reports/delivery-notes";
	}
}
